import { useEffect } from 'react'
import { useRouter } from 'next/router'
import i18n from '@/lib/i18n'
import { getLocaleFromPath, getPublicPath } from '@/lib/locales'

export default function LocaleSync() {
  const router = useRouter()

  useEffect(() => {
    const locale = getLocaleFromPath(getPublicPath(router.asPath))
    document.documentElement.lang = locale

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale)
    }
  }, [router.asPath])

  return null
}
